module.exports = __webpack_public_path__ + "mo/img/image 365.9f84d427.webp";